import { createApiSlice } from "@common";
import {
    MY_INFO_NOMINEE
} from "@routes";

// Define the API config array
const apiConfig = [
    {
        name: "addEmployeeNomineeDetails",
        method: "post",
        url: MY_INFO_NOMINEE,
        stateKey: "message",
    },
    {
        name: "getEmployeeNomineeDetails",
        method: "get",
        url: MY_INFO_NOMINEE,
        stateKey: "data",
    },
    {
        name: "updateEmployeeNomineeDetails",
        method: "put",
        url: MY_INFO_NOMINEE,
        stateKey: "message",
    },
    {
        name: "deleteEmployeeNomineeDetails",
        method: "delete",
        url: MY_INFO_NOMINEE,
        stateKey: "message",
    },
];

// Define custom reducers and their initial state
const customReducers = {
    initialState: {
        data: [],
        additionalData: [],
    },
    reducers: {
        setAdditionalData: (state, action) => {
            state.additionalData = action.payload;
        },
    },
    extraReducers: {
        // Example of custom extra reducer
        someCustomAction: (state, action) => {
            // Custom reducer logic
        },
    },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
    "EmployeeNomineeDetails",
    apiConfig,
    customReducers,
);
const EmployeeNomineeDetailsSlice = slice;
// Export the slice's reducer
export default EmployeeNomineeDetailsSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
    addEmployeeNomineeDetails,
    getEmployeeNomineeDetails,
    updateEmployeeNomineeDetails,
    deleteEmployeeNomineeDetails
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
    actions;
